export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost'

export function buildApiUrl(path) {
  const base = API_BASE_URL.replace(/\/+$/, '')
  const suffix = path.startsWith('/') ? path : `/${path}`
  return `${base}${suffix}`
}

export function resolveAssetUrl(path) {
  if (!path) {
    return ''
  }

  if (/^https?:\/\//i.test(path) || path.startsWith('data:')) {
    return path
  }

  return buildApiUrl(path)
}
